import React from 'react';

import SolidSpinner from '../../Icons/Solid/spinner-third.svg?react';
import LightSpinner from '../../Icons/Light/spinner-third.svg?react';
import { classNames } from '../../Services/helpers';
import CommonFieldWrapper from '../Form/Fields/CommonFieldWrapper';
import Text from '../Formatting/Text';
import { useOffline } from '../Offline';
import Icon from '../Icons/Icon';

const Loading = ({className, size, bg = "light", center}) => {
    const {isOnline} = useOffline();

    const sizes = {
        '0.5x': 'h-2 w-2',
        '1x': 'h-4 w-4',
        '2x': 'h-6 w-6',
        '3x': 'h-8 w-8',
        '4x': 'h-10 w-10',
    }
    const sizeClass = sizes[size] ?? sizes['1x'];

    const fullClassName = classNames(
        'inline-block relative',
        sizeClass,
        className,
        center && 'm-auto'
    );

    const solidColour = bg === 'dark' ? 'fill-brand-light' : 'fill-brand';
    const lightColour = bg === 'dark' ? 'fill-white' : 'fill-brand-light';

    let spinner = <span className={fullClassName}>
        <SolidSpinner className={'animate-spin absolute top-0 left-0 h-full w-full '+solidColour} />
        <LightSpinner className={'animate-spin-fast absolute top-0 left-0 h-full w-full '+lightColour} />
    </span>

    if (!isOnline) {
        spinner = <span className={fullClassName}>
            <Icon icon="WifiSlash" />
        </span>
    }

    return center ? <p className="text-center">{spinner}</p> : spinner;
}

const PageLoading = ({message, short}) => {
    const {isOnline} = useOffline();

    if (!isOnline) {
        return <div className={classNames('flex flex-col items-center justify-center', short ? 'my-5' : 'my-20')}>
            <Icon size="4x" icon="WifiSlash" className="fill-muted" />
            <p className="text-center text-muted text-sm mt-4">
                You're offline. Please check your internet connection and try again.
            </p>
        </div>
    }

    return <>
        <Loading size="4x" className={short ? 'my-5' : 'my-20'} center />
        {message && <p className="text-center text-muted mt-4"><Text>{message}</Text></p>}
    </>
}

const FieldLoading = ({label}) => {
    return <CommonFieldWrapper {...{label}}>
        <Loading size="2x" center />
    </CommonFieldWrapper>
}

export default Loading;

export {
    PageLoading,
    FieldLoading,
}
